import { formatPrismicData } from '@monofront/business/utils';
import { IPrismicRichText } from '@monofront/types';

export const mapSmallCenteredText = ({ prismicContent }): IPrismicRichText => {
  const { primary } = formatPrismicData(prismicContent);

  return primary.text;
};
